module.exports = "<form content novalidate=\"novalidate\" autocomplete=\"off\">\n    <input type=\"submit\" value=\"{{ content('login.loginBtn') }}\" class=\"btn full loginBtn frameBustBtn\" ng-click=\"actions.submit()\" />\n</form>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-framebust/template.html
// module id = ./pages/xo-framebust/template.html
// module chunks = 0